import DayjsUtils from '@date-io/dayjs';
import Button from '@material-ui/core/Button';
import { makeStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import SearchIcon from '@material-ui/icons/Search';
import React, { useState } from "react";
import { useActions, useValues } from 'kea';

import profilelogic from 'src/store/profile';
import vehiclelogic from 'src/store/vehicle';
import checkRole from 'src/utils/checkRole';


const useStyles = makeStyles({
	root: {
		minWidth: "100%"
	},
	table: {
		minWidth: "500px",
		maxHeight: 400
	},
	limitFont: {
		fontSize: 13
	}
});


export default function History({ vehicle }) {
	const classes = useStyles();

	const { nearbyAssets } = useValues(vehiclelogic);
	const { fetchNearbyAssets } = useActions(vehiclelogic);
	const { profile } = useValues(profilelogic);

	const [selectedDate, handleDateChange] = useState(new Date());

	const handleSearch = () => {
		const enddate = new Date();
		const startdate = new Date();
		startdate.setMinutes(enddate.getMinutes() - 2);
		fetchNearbyAssets({
			_id: vehicle._id,
			start: startdate,
			stop: enddate
		})
	}

	return (
		<div className={classes.root} >
			<TableContainer style={{ maxHeight: '400px' }}>
				<Table stickyHeader size="small" aria-label="a dense table" className={classes.table}>
					<TableHead>

						{
							checkRole(profile, ['AssetEdit', 'AssetView']) &&
							<TableRow key={"type-rego"}>
								<TableCell align="right"  >
									Nearby assets:
								</TableCell>
								<TableCell align="left" style={{ paddingLeft: 0 }}>
									<Button
										variant="contained"
										color="primary"
										size="small"
										className={classes.button}
										startIcon={<SearchIcon />}
										onClick={handleSearch}
									>
										Search
									</Button>
									{/* <IconButton type="submit" className={classes.iconButton} aria-label="search">
								<SearchIcon />
							</IconButton> */}
								</TableCell>
							</TableRow>}
					</TableHead>
					<TableBody >
						{
							// rows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row) => (
							nearbyAssets?.map((row, index) => (
								<TableRow key={`inginition-address-${index}`}>
									<TableCell colSpan={2} className={classes.limitFont} style={{ minWidth: '170px' }} align="left">
										{row.name}
									</TableCell>
								</TableRow>
							))
						}
						{/* {emptyRows > 0 && (
					<TableRow style={{ height: 49 * emptyRows }}>
						<TableCell colSpan={6} />
					</TableRow>
				)} */}
					</TableBody>
				</Table>
			</TableContainer>

			{/* <TablePagination
			rowsPerPageOptions={[5,10,15]}
			component="div"
			count={rows.length}
			rowsPerPage={rowsPerPage}
			page={page}
			onChangePage={handleChangePage}
			onChangeRowsPerPage={handleChangeRowsPerPage}
		/> */}
		</div>
	);
}
